
/**
 * Email types and interfaces
 */

/**
 * Result of email sending operation
 */
export interface EmailResult {
  adminSent: boolean;
  customerSent: boolean;
  success: boolean;
  errorMessage?: string;
}

/**
 * Email error handling utility type
 */
export interface EmailErrorInfo {
  title: string;
  message: string;
}

/**
 * Maps error types to user-friendly messages
 */
export const getEmailErrorInfo = (error: Error | unknown): EmailErrorInfo => {
  const errorString = String(error);
  
  if (errorString.includes('404') || errorString.includes('not found')) {
    return {
      title: "Servicio no encontrado",
      message: "Servicio de email no encontrado. Verifica la configuración de EmailJS."
    };
  } else if (errorString.includes('401') || errorString.includes('unauthorized')) {
    return {
      title: "Credenciales incorrectas",
      message: "Credenciales de email incorrectas. Verifica la configuración de EmailJS."
    };
  } else if (errorString.includes('network')) {
    return {
      title: "Error de conexión",
      message: "Error de conexión a internet. Por favor verifica tu conexión."
    };
  } else if (errorString.includes('service_id')) {
    return {
      title: "ID de servicio no encontrado",
      message: "ID de servicio no encontrado. Verifica la configuración de EmailJS."
    };
  }
  
  return {
    title: "Error al enviar email",
    message: "Por favor, intenta nuevamente más tarde."
  };
};
